
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import GTAGCONFIG from './util/gtag/config'
import 'video.js/dist/video-js.css';
GTAGCONFIG.appendGtagJs()
console.log(screen.width + ' * ' + screen.height)
window.HELP_IMPROVE_VIDEOJS = false;

ReactDOM.render(<App />, document.getElementById('root'));